<template>
	<div class="content_group ">
		<!-- content_group -->

		<div class="content_group_R  ">
			<!-- content_group_R -->
			<el-skeleton :rows="20" :loading="loadingMask" animated>
				<div class="thematic_list  ">
					<!-- thematic_list -->
					<section v-for="(result,index) in resultDataList" :key="result.id">
						<dl>
							<dt>
								<div class="T-date">
									<d1>{{result.publishtime?result.publishtime.substring(8,10):''}}</d1>
									<d2>{{result.publishtime?result.publishtime.substring(0,7):''}}</d2>
								</div>
							</dt>
							<dd v-if="hidesummary">
								<a @click="jumppush('/detail/'+result.id+'/1?col='+sourcecol)" class="T-tit"
									v-html="(showtype?'【'+ result.articletype +'】':'')+result.title" target="_blank" :style="{'margin-top':result.summary?'':'7px'}">
								</a>
							</dd>
							<dd v-else>
								<a @click="jumppush('/detail/'+result.id+'?col='+sourcecol)" class="T-tit"
									v-html="(showtype?'【'+ result.articletype +'】':'')+result.title" target="_blank" :style="{'margin-top':result.summary?'':'7px'}">
								</a>
							</dd>
						</dl>
						<!-- <dl>
						<dt></dt>
						<dd class="T-fla">
							<span class="T-source">来源：{{result.source}}</span>
						</dd>
					</dl> -->
						<dl v-if="!hidesummary">
							<dt>
								<T-vline></T-vline>
							</dt>
							<dd v-if="result.summary&&result.summary.indexOf('attachment')<0">
								<ul class="list4">
									<li>
										<a @click="jumppush('/detail/'+result.id+'?col='+sourcecol)" target="_blank">
											{{result.summary}}</a>
									</li>
								</ul>
							</dd>
						</dl>
					</section>

				</div><!-- /thematic_list -->
			</el-skeleton>

			<div class="m_b1"></div>


			<el-row class="pagediv">
				<el-pagination @size-change="changePageSize" @current-change="changeSearchPage" :current-page="pageNum"
					:page-sizes="[10, 15, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
					:total="totalResultCount">
				</el-pagination>
			</el-row>




		</div><!-- /content_group_R -->
	</div><!-- /content_group -->
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
			}
		},
		props: [
			'ztsubid',
			'showtype',
			'hasPower',
			'areacode',
			'areacodetag',
			'hidesummary',
			'sourcecol',
		],
		mounted: function() {
			this.searchfnc();
		},
		watch:{
			ztsubid(){
				this.searchInit();
			},
			areacode(){
				this.searchInit();
			},
			areacodetag(){
				this.searchInit();
			},
		},
		methods: {
			jumppush:function(to){
				if(!this.hasPower){
					alert('您未购买此栏目!');
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			searchInit:function(){
				this.pageNum = 1;
				this.pageSize = 10;
				this.searchfnc();
			},
			searchfnc: function() {
				// console.log(this.ztsubid+'/'+this.showtype);
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'subject/getSubjectColumnArticles',
						responseType: 'json',
						params: {
							columnID: this.ztsubid,
							iPage: this.pageNum,
							pageSize: this.pageSize,
							areacode: this.areacode?this.areacode:'',
							areacodetag: this.areacodetag?this.areacodetag:'',
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.data;
						_this.totalResultCount = response.data.data.data.totalcount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.searchfnc();
				debugger
				document.body.scrollTop = document.getElementById('zhuantitabs').offsetTop;
				document.documentElement.scrollTop = document.getElementById('zhuantitabs').offsetTop;
			},
		}
	}
</script>

<style>
	.list4 li a:before {
		content: none;
		white-space: normal;
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
	.list4 li a {
		white-space: normal;
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
	.thematic_list section:hover a.T-tit{
		color: #bd1a2d;
	}
	.thematic_list .list4 a:hover{
		color: #a1a4ab;
	}
</style>
